// external imports
import { generate, generateQuery, QueryType } from 'typegraph';

// internal imports
import Service from 'core/decorators/Service';
import IQueryService, { IManyResult, IOneResult, IRootResult, QueryAlias } from 'core/service/query/IQueryService';
import IResolverService from 'core/service/resolver/IResolverService';
import Class from 'core/util/Class';
import Logger from 'core/util/Logger';
import ServiceRegistry from 'core/util/ServiceRegistry';

@Service()
export default class QueryService extends IQueryService {

	public findOne<T>(entity: Class<T>, params: object, variables?: object): Promise<IOneResult<T>> {

		// generate a "one" query
		const query = this.getQuery(QueryType.ONE, entity, params);

		// get the http resolver service
		const resolver = ServiceRegistry.get(IResolverService);

		// return the promise
		return resolver.execute(query, variables);
	}

	public findMany<T>(entity: Class<T>, params: object, variables?: object): Promise<IManyResult<T>> {

		// generate a "many" query
		const query = this.getQuery(QueryType.MANY, entity, params);

		// get the http resolver service
		const resolver = ServiceRegistry.get(IResolverService);

		// return the promise
		return resolver.execute(query, variables);
	}

	public find(type: QueryType, entity: Class<any>, params: object, variables?: object): Promise<any> {

		// generate a generic query
		const query = this.getQuery(type, entity, params);

		// get the http resolver service
		const resolver = ServiceRegistry.get(IResolverService);

		// return the promise
		return resolver.execute(query, variables);
	}

	public load<T>(operationClazz: Class<T>, data: any = {}, variables: any = {}): Promise<IRootResult<T>> {
		const query = generate.root(operationClazz, data);

		const resolver = ServiceRegistry.get(IResolverService);

		return resolver.execute(query, variables);
	}

	private getQuery(type: QueryType, entity: Class<any>, params: object): string {

		// preface the params. its assumed that every query takes a parameters object called "params".
		// this is due to the graphql-java-tools implementation in the graphql controller
		const queryParams = { params };

		// generate the query using TypeGraph
		// alias it to the respective QueryAlias values
		const query = generateQuery(entity, type, queryParams, QueryType.MANY === type ? QueryAlias.MANY : QueryAlias.ONE);

		// output in development mode only
		Logger.debug("generated query: %s", query);

		return query;
	}

	public getServiceId(): string {
		return IQueryService.DEFAULT_ID;
	}
}



// WEBPACK FOOTER //
// ./src/core/service/query/impl/Query.service.ts